// src/components/Home.js
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ShowIfLoggedIn, ShowIfNotLoggedIn } from '../features/auth/auth_utils';


      // backgroundImage: 'linear-gradient(to bottom, #33ccff 0%, #ff99cc 100%)',
      // backgroundImage: 'linear-gradient(to right, #ff7e5f, #feb47b)',
function Home() {
  const customStyle = {
      color : '#009933',  // Text Color - crimson
      backgroundColor: 'beige', // Background color
      padding: '10px',
      borderRadius: '5px'
    };
  return (
    <Container className="my-2 vh-100 justify-content-center align-items-center">
      <h2 className="mb-3">MF Schemes exploration for meaningful Recommendation</h2>
      <h4>
        Complementing your Smart Investment decisions in Mutual Funds.
      </h4>
      <p className="mb-2" style={customStyle}>
        <b>Welcome to India based Mutual Fund Scheme's Net Asset Value Prediction (pNAV) Platform.</b> SignUp for free.
      </p>
      <p>
            This AI based solution lists past and predicted performance, which includes predicted NAV (pNAV) for selected India based Mutual Fund schemes.
      </p> 
      <p>
          After you login/ signIn, system displays mutual fund schemes tracked by this pNAV calculator. <b>The list is sorted after considering predicted and past performance. </b>
          <b>Additional details</b> can be viewed by clicking the scheme. At this point you have a choice of comparing and analyzing Alternative/ SimilarSchemes.
          Fund Houses must have been selected using "Select Funds" menu item to get an idea of how the current scheme perfoms against Alternatives and similar schemes from Selected Funds.
      </p>
      <p>
          Check Navigation bar menu items. Apart from all tracked schemes, one can also list of Schemes from selected funds. You can also prepare your own WatchList. This will shorten your time to periodically watch/ review the progress of those schemes.
      </p>
      <p>
          <i>Displayed values of pNAV and Historic Data are updated every week.</i>
      </p>
      <div className="mb-3" style={customStyle}> <b>Steps to get started:</b>
        <ol className="m-2">
          <li>Sign Up / Register using your email id.</li>
          <li>Verify your email using the link sent to your registered email id.</li>
          <li><i>Wait for account activation. Should not take more than 2 hours.</i></li>
          <li>Login using your email id and password.</li>
          <li>Explore listed schemes along with their predicted NAV (pNAV) and historic data.</li>
          <li>.....</li>
          <li>Select <b>fund houses</b> of your interest. This will allow you to compare and analyze a scheme against similar and alternate schemes.</li>
          <li>One can add Schemes to <b>Watchlist</b> which can be created on the fly. Multiple watchlists will allow you to track your scheme groups easily.</li>
          <li>.....</li>
          <li>Excel Integration Available ... Check your eligibility</li>
        </ol>
      </div>
      <ShowIfNotLoggedIn>
        <Button as={Link} to="/login" className="me-2">
          Sign In
        </Button>
        <Button as={Link} to="/signup" variant="outline-primary">
          Sign Up
        </Button>
        <p style={{ fontSize: '90%' }} className="mt-2">
        Leverage the platform to complement your smart investment decisions. We await your feedback and suggestions.
        </p>
      </ShowIfNotLoggedIn>
      <ShowIfLoggedIn>
            <Button as={Link} to="/dashboard" variant="outline-primary">Navigate to Tracked Schemes</Button>
      </ShowIfLoggedIn>
      <footer style={{ fontSize: '80%' }} className="mt-2">
        <p>
        <b>FYI:</b> <u>AbhisaraNa</u> / Abhisaraṇa (<b>अभिसरण</b>) in Samskrutam (Sanskrit) refers primarily to the act of approaching, going towards, or meeting/ Convergence. Frequently used in literature to describe a lover's journey to a secret rendezvous.
        </p>
        <p>
          Derived from abhi (towards) + sṛ (to go)
        </p>
      </footer>
    </Container>
  );
}

export default Home;

